import { Button, Modal } from 'antd';
import { hideAlert } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { DialogIcon } from './DialogIcon';
import { AlertModalProps } from './Modal.type';

export const AlertModalComponent = ({
    open = true,
    type,
    title,
    message,
    icon,
    okText = 'いいえ',
    cancelText,
    onOk,
    returnValue,
    ...props
}: AlertModalProps) => {
    const dispatch = useAppDispatch();

    const handleCancel = () => {
        dispatch(hideAlert());
        if (returnValue) {
            onOk && onOk(returnValue);
            return;
        }
        onOk && onOk();
    };
    return (
        <Modal
            width={'fitContent'}
            open={open}
            footer={null}
            centered
            className={'modal-info alert__modal' + `${props.className ?? ''}`}
        >
            <section style={{ paddingTop: 12, paddingBottom: 4 }}>
                <div style={{ width: '100%' }} className="center-inside">
                    <DialogIcon type={type} icon={icon} />
                </div>
                <div className="confirm-modal-2-title" style={{ marginBottom: 8, marginTop: 32 }}>
                    {title}
                </div>
                <div
                    className="confirm-modal-2-description"
                    style={{ marginBottom: 32, color: '' }}
                >
                    {message}
                </div>
                {okText && (
                    <Button
                        type="primary"
                        className="button-login-text"
                        style={{ width: '100%', height: 48 }}
                        onClick={() => handleCancel()}
                    >
                        {okText}
                    </Button>
                )}
                {cancelText && (
                    <Button
                        type="link"
                        block
                        className="text-button-cancel"
                        style={{ width: '100%', height: 48 }}
                        onClick={() => handleCancel()}
                    >
                        {cancelText}
                    </Button>
                )}
            </section>
        </Modal>
    );
};
